import { RcFile } from 'antd/lib/upload';

import Utility from 'api/classes/Utility';
import { POST } from 'api/constants';

export const uploadFormDataFile = async(file: RcFile, url: string) => {
  const data = new FormData();

  data.append('file', file);
  const config = { headers: { dontConvert: true } };

  return await Utility.customRequest({ url, method: POST, data, config });
};
